import React, { useMemo } from 'react';

import { Upsell } from '.';
import { track } from '../../utils/tracking';
import { productLineToViewMapping } from '../constants/mappings';
import { useGlobalState } from '../hooks/global';

const ViewAccessWrapper = ({ viewName, viewComponent, allowPreview = false }) => {
  const { accessibleFeatures, account, user } = useGlobalState();
  const isRockerboxer = user?.username.includes('@rockerbox.com');
  const hasOverride = allowPreview && isRockerboxer;

  const hasAccess = useMemo(() => {
    if (accessibleFeatures === null) return;
    return accessibleFeatures.includes(viewName);
  }, [accessibleFeatures, hasOverride]);

  const findProductLine = (data, target) => {
    const productLine = Object.keys(data).find(line => data[line].includes(target));
    return productLine || 'missing';
  };

  if (hasAccess === undefined) return null;

  if (hasAccess === false && !hasOverride) {
    const productLine = findProductLine(productLineToViewMapping, viewName);
    track(`${viewName}.${productLine}.upsell`, { advertiser: account?.advertiser_name });
    return (
      <Upsell productLine={productLine} />
    );
  }

  return (
    <>
      {hasOverride && !hasAccess && (
        <p style={{ color: 'red' }}>
          This view may not be available to the client yet!
        </p>
      )}
      {viewComponent}
    </>
  );
};

export default ViewAccessWrapper;
